<template>
  <div class="feelist">
    <div>
      <div class="price-title">배송요금</div>
      <div class="price-lists">
        <div class="price-list" v-for="(list, idx) in renderList">
          <div class="price-list__title">
            {{ mixinsFeeTitle(list.value) }}
            <img
              v-if="list.toggle"
              class="price__img"
              src="@/assets/img/order/qmark.svg"
            />
            <tooltip
              v-if="list.toggle"
              class="tooltip general-tooltip"
              :type="list.toggle"
            />
          </div>
          <div class="price-list__price">
            {{ deliveryOptions[list.value].toLocaleString() }}원
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="price-title">할증요금</div>
      <div class="price-lists">
        <div class="price-list" v-for="(list, idx) in additionalFeeList">
          <div class="price-list__title">
            {{ mixinsFeeTitle(list.value) }}
            <img
              v-if="list.toggle"
              class="price__img"
              src="@/assets/img/order/qmark.svg"
            />
            <tooltip
              v-if="list.toggle"
              class="tooltip general-tooltip"
              :type="list.toggle"
            />
          </div>
          <div class="price-list__price">
            {{ deliveryOptions[list.value].toLocaleString() }}원
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="price-list">
        <div class="price-list__title--vat">
          {{ mixinsFeeTitle("vat") }}<span>(10%)</span>
        </div>
        <div class="price-list__price">
          {{ deliveryOptions.vat.toLocaleString() }}원
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixinFilter from "@/mixins/mixinFilter";
import tooltip from "@/components/common/tooltip.vue";
export default {
  props: ["deliveryOptions"],
  mixins: [mixinFilter],
  components: { tooltip },
  data() {
    return {
      deliveryFeeList: [
        {
          value: "baseFee",
          toggle: null,
        },
        {
          value: "distanceFee",
          toggle: "distanceFee",
        },
        {
          value: "weightFee",
          toggle: "weightFee",
        },
        {
          value: "waypointsFee",
          toggle: "waypointsFee",
        },
        {
          value: "expressDeliveryFee",
          toggle: null,
        },
        {
          value: "fixedFee",
          toggle: null,
        },
      ],
      freightDeliveryFeeList: [
        {
          value: "freightDistanceFee",
          toggle: null,
        },
        {
          value: "freightOptionsFee",
          toggle: "freightOptionsFee",
        },
        {
          value: "waypointsFee",
          toggle: "freightWaypointsFee",
        },
        {
          value: "expressDeliveryFee",
          toggle: null,
        },
        {
          value: "fixedFee",
          toggle: null,
        },
      ],
      additionalFeeList: [
        {
          value: "timeChargeFee",
          toggle: "timeChargeFee",
        },
        {
          value: "weatherChargeFee",
          toggle: "weatherChargeFee",
        },
        {
          value: "specialDayChargeFee",
          toggle: "specialDayChargeFee",
        },
        {
          value: "extraFixedFee",
          toggle: null,
        },
      ],
    };
  },

  computed: {
    renderList() {
      let list = [];
      if (this.deliveryOptions.vehicleItemCode === 1) {
        list = _.cloneDeep(this.deliveryFeeList);
      } else {
        list = _.cloneDeep(this.freightDeliveryFeeList);
      }

      return list;
    },
  },
};
</script>
<style scoped>
.feelist {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
}
.price-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: var(--gray-600);
  margin-bottom: 8px;
}
.price-lists {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.price-list {
  display: flex;
  justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.price-list__title {
  color: var(--gray-500);
  display: flex;
  align-items: center;
}
.price-list__title--vat {
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: var(--gray-600);

  display: flex;
  align-items: flex-end;
}

.price-list__title--vat span {
  font-size: 10px;
}

.price-list__title img {
  cursor: pointer;
}

.tooltip {
  display: none;
}
.price__img {
  /* position: relative; */
}
.price-list__title {
  position: relative;
}
.price__img:hover + .general-tooltip {
  position: absolute;
  display: block;
  margin-top: 20px;
  top: 0;
  z-index: 99999999;
}
.price-list__price {
  color: var(--gray-600);
}

.caution {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: var(--gray-600);
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
</style>
